import { useEffect, useState } from "react";
import { api } from "../App";

export default function AccountSelect({ value, onChange, label = "Cuenta de origen", disabled = false }) {
  const [accounts, setAccounts] = useState([]);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let active = true;
    api.get("/accounts").then(({ data }) => { if (active) setAccounts(data.accounts.filter(a => !a.archived)); })
      .catch(() => { if (active) setFailed(true); });
    return () => { active = false; };
  }, []);
  return <label className="text-sm w-full block">{label}
    <select className="w-full border rounded-xl p-2 bg-white text-slate-800" aria-label={label} value={value || "unassigned"} disabled={disabled || failed} onChange={e => onChange(e.target.value, accounts.find(a => a.id === e.target.value))}>
      <option value="unassigned">Por ubicar · sin cuenta asignada</option>
      {accounts.map(a => <option key={a.id} value={a.id}>{a.name} · {a.currency}</option>)}
    </select>
    {failed && <span role="alert">No se pudieron cargar las cuentas. Vuelve a abrir el formulario.</span>}
  </label>;
}
